import React, { createContext, useReducer } from 'react';

import reducer, { ContextType, getInitialState } from './Util/State';

const StateContext = createContext({} as ContextType);

const StateProvider = ({ children }: any): React.ReactElement => {
  const [state, dispatch] = useReducer(reducer, getInitialState());
  const value = { state, dispatch };

  return (
    <StateContext.Provider value={value}>{children}</StateContext.Provider>
  );
};

export { StateContext, StateProvider };
